import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiAppPlatform } from '../../Apps';
import type { IApiBuildsResponseBody } from '../BuildsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseBuildsQueryValues = {
  appId: string;
  platform?: IApiAppPlatform;
  withHistory?: boolean;
};

export const buildsQueryKeyFactory: IQueryKeyFactory<IUseBuildsQueryValues> = (
  values,
) => values && (['builds', values.appId, values.platform ?? null] as const);

export const useBuildsQuery = (
  values?: IUseBuildsQueryValues,
  options?: UseQueryOptions<IApiBuildsResponseBody, ApiError>,
): UseQueryResult<IApiBuildsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: buildsQueryKeyFactory(values),
    queryFn: values
      ? () =>
          api.builds.getAll(values.appId, values.platform, values.withHistory)
      : undefined,
    ...options,
  });
};
